<template>
  <div>
    <tree-item 
      v-for="(i, $index) in itemsData" 
      :i-data="i"
      :key="$index">
    </tree-item>
  </div>
</template>

<script>
import TreeItem from './tree-item.vue'

export default {
  name: 'reports-tree',
  methods: {

  },
  props: ['itemsData'],
  components: {
    TreeItem
  }
}
</script>

<style>
.strategio-folder-toggle {
  cursor: pointer;
}
.strategio-tree-children {
  padding-left: 32px;
}
.strategio-tree-folder {
  padding: 0px !important;
  margin: 0px !important;
}
.strategio-tree-item {
  padding: 0px 0px 0px 32px !important;
  margin: 0px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/reports/reports-tree.vue